// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hwox7","icon":"styles_icon__2Mmne"};